








































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { Seller } from '~/models/classified/types'
import CClassifiedSellerCard from '~/components/shared/configurable/classified/seller/CClassifiedSellerCard.vue'
import { mapGetters, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { APP_NS } from '~/store/modules/shared/app/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ScrollService from '~/services/scroll/ScrollService'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { toCamelCase } from '~/utils/object'
import CStarRating from '~/components/shared/configurable/rating/CStarRating.vue'
import MarketplaceSellerRating from '~/components/car/marketplace/seller/MarketplaceSellerRating.vue'
import { defineVue3AsyncComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: {
    MarketplaceSellerRating,
    CStarRating,
    CClassifiedSellerCard,
    CCard,
    PropertyManagerInfo: defineVue3AsyncComponent(() =>
      import('~/components/shared/classified/view/PropertyManagerInfo.vue')
    ),
    GoogleRating: defineVue3AsyncComponent(() =>
      import(
        '~/components/car/classifieds/view/partials/google-rating/GoogleRating.vue'
      )
    )
  },
  props: {
    seller: {
      type: Object as PropType<Seller>,
      required: true
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      contactSchema: state => state.contactSchema,
      classified: state => state.classified,
      marketplace: state => state.marketplace
    }),
    ...mapDeps({
      scrollService: ScrollService
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerIsOfTypeDealer: 'sellerIsOfTypeDealer',
      sellerIsOfTypeAgent: 'sellerIsOfTypeAgent',
      sellerIsConstructionCompany: 'sellerIsConstructionCompany',
      isWantedPartsClassified: 'isWantedPartsClassified'
    }),
    ...mapGetters(USER_NS, {
      isDealer: 'isOfTypeDealer',
      isAgent: 'isAgent'
    }),
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot'
    }),
    icons() {
      return {
        externalLink: ciExternalLink
      }
    },
    googleRatings() {
      return toCamelCase(this.seller.google_rating)
    },
    pageLabel() {
      if (this.sellerIsConstructionCompany) {
        return this.$t('construction company')
      } else if (this.sellerIsOfTypeAgent) {
        return this.$t('agent page')
      } else if (this.isWantedPartsClassified) {
        return this.$t('dealer_classifieds')
      }

      return this.$t('dealer page')
    }
  },
  methods: {
    scrollToContactSection() {
      const contactElem = document.getElementById('contact')

      if (contactElem) {
        this.scrollService.scrollTo(contactElem, {
          duration: 500,
          easing: 'ease-out',
          offset: -50,
          onDone: () => {
            try {
              contactElem.classList.add('highlight')
              setTimeout(() => {
                contactElem.classList.remove('highlight')
              }, 3000)
            } catch (e) {
              this.$logger.captureError(e as Error)
            }
          }
        })
      }
    },
    handleInternalPageClick() {
      this.$analytics.recordEvent({
        namespace: 'n_click_seller_internal_page',
        action: 'click'
      })
    }
  }
})
